<template>
    <header id="header" class="fixed-top">
        <nav class="navbar justify-content-between">
        <div class="left-container">
            <h1 class="logo">
            <a href="/">GCRM </a>
            </h1>
            <!-- navi -->
            <ul class="navbar-nav" v-if="state">
                <li class="nav-item" v-for="(menu, index) in rootMenus" :key="menu.menuId" :index="menu.menuId">
                    <a href="#none" class="menu-1depth" :class="{'on' : menuSelectedIndex === index && menu.isNavOpen }" @click="navClick(menu, index, rootMenus)">{{ getLabel(menu) }}</a>
                    <transition name="fade">
                        <ul class="sub-nav" v-if="menuSelectedIndex === index && menu.isNavOpen">
                            <li class="sub-item" v-for="(submenu,subIndex) in getSubmenu(menu.menuId)" :key="submenu.menuId" :index="submenu.menuId">
                            <template v-if="getSubmenu(submenu.menuId).length > 0">
                                <a href="javascript:void(0)" class="menu-2depth isSub collapsed" v-b-toggle='"subaccordion-" + subIndex'>{{ getLabel(submenu) }}</a>
                                <b-collapse :id='"subaccordion-" + subIndex' accordion="my-accordion" class="sub">
                                    <ul class="sub-list">
                                        <li v-for="item in getSubmenu(submenu.menuId)" :key="item.menuId">
                                            <a href="javascript:">{{ getLabel(item) }}</a>
                                        </li>
                                    </ul>
                                </b-collapse>
                            </template>
                            <template v-else>
                                <a href="#" class="menu-2depth">{{ getLabel(submenu) }}</a>
                            </template>
                            </li>
                        </ul>
                    </transition>
                </li>
            </ul>
            <!-- //navi -->
        </div>

        <!-- right menu -->
        <div class="right-container">
            <div v-if="state" class="myinfo">
            <button type="button" class="btn-myinfo" @click="onInfoClick">Gildong Hong</button>
            <transition name="slide">
                <div v-if="isMyInfoActive" class="myinfo-dropdown">
                    <div class="in">
                        <div class="info-hd">HQ Admin</div>
                        <div class="info-cnt">
                            <ul class="ul">
                                <li v-for="(item,index) in myinfos" :key="item.menu">
                                    <button type="button" class="i-menu collapsed" v-b-toggle='"accordion-" + index'>{{ item.menu }}</button>
                                    <b-collapse :id='"accordion-" + index' accordion="my-accordion" class="sub">
                                        <ul>
                                            <li v-for="subItem in item.submenus" :key="subItem">{{ subItem }}</li>
                                        </ul>
                                    </b-collapse>
                                </li>
                            </ul>
                        </div>
                        <div class="info-btm">
                            <button type="button" class="btn btn-secondary btn-xs">Logout</button>
                        </div>
                    </div>
                </div>
            </transition>
            </div>
            <div class="lang">
                <select class="form-control">
                    <option>KOR</option>
                    <option>ENG</option>
                </select>
            </div>
        </div>
        </nav>
    </header>
</template>

<script>
import _ from 'lodash';
import SDLLocale from '@/mixin/SDLLocale';

export default {
    props: {
        state: {
        type: Boolean,
        default: true,
        },
    },
    mixins: [SDLLocale],
    data(){
        return {
            pubMenus: [
                //GCRM menu
                { menuLevel: 1, menuId: "mL1",       depth1:'GCRM',       labelJson: { en_US: "GCRM", ko_KR: "GCRM" }, isNavOpen:false, },
                { menuLevel: 2, menuId: "mL1L2-1",   parentId: "mL1",     labelJson: { en_US: "Campaign", ko_KR: "Campaign" } },
                { menuLevel: 3, menuId: "mL1L2L3-1", parentId: "mL1L2-1", labelJson: { en_US: "China", ko_KR: "China" } },
                { menuLevel: 3, menuId: "mL1L2L3-2", parentId: "mL1L2-1", labelJson: { en_US: "SEAO", ko_KR: "SEAO" } },
                { menuLevel: 2, menuId: "mL1L2-2",   parentId: "mL1",     labelJson: { en_US: "Loyalty", ko_KR: "Loyalty" } },
                { menuLevel: 3, menuId: "mL1L2L3-1", parentId: "mL1L2-2", labelJson: { en_US: "Korea", ko_KR: "Korea" } },
                { menuLevel: 3, menuId: "mL1L2L3-2", parentId: "mL1L2-2", labelJson: { en_US: "EU", ko_KR: "EU" } },

                //GCRM BI
                { menuLevel: 1, menuId: "mL2",       depth1:'Analytics',    labelJson: { en_US: "Analytics", ko_KR: "Analytics" }, isNavOpen:false, },
                { menuLevel: 2, menuId: "mL2L2-1",   parentId: "mL2",     labelJson: { en_US: "BI", ko_KR: "BI" } },
                { menuLevel: 3, menuId: "mL2L2L3-1", parentId: "mL2L2-1", labelJson: { en_US: "BI", ko_KR: "BI" } },

                //VOC
                { menuLevel: 1, menuId: "mL3",       depth1:'SUPPORT',        labelJson: { en_US: "SUPPORT", ko_KR: "SUPPORT" }, isNavOpen:false, }, //220907 : 기획 메뉴명수정 (VOC -> Support)
                { menuLevel: 2, menuId: "mL3L2-1",   parentId: "mL3",     labelJson: { en_US: "권한요청", ko_KR: "권한요청" } },
                { menuLevel: 3, menuId: "mL3L2L3-1", parentId: "mL3L2-1", labelJson: { en_US: "신청하기", ko_KR: "신청하기" } },
                { menuLevel: 3, menuId: "mL3L2L3-2", parentId: "mL3L2-1", labelJson: { en_US: "신청현황조회", ko_KR: "신청현황조회" } },
                { menuLevel: 2, menuId: "mL3L2-2",   parentId: "mL3",     labelJson: { en_US: "Lock 해제", ko_KR: "Lock 해제" } },  //220907 : 기획 메뉴명수정 (VOC요청 -> Lock 해제)
                { menuLevel: 3, menuId: "mL3L2L3-1", parentId: "mL3L2-2", labelJson: { en_US: "신청하기", ko_KR: "신청하기" } },
                { menuLevel: 3, menuId: "mL3L2L3-2", parentId: "mL3L2-2", labelJson: { en_US: "신청현황조회", ko_KR: "신청현황조회" } },
                { menuLevel: 2, menuId: "mL3L2-3",   parentId: "mL3",     labelJson: { en_US: "데이터요청", ko_KR: "데이터요청" } },
                { menuLevel: 3, menuId: "mL3L2L3-1", parentId: "mL3L2-3", labelJson: { en_US: "신청하기", ko_KR: "신청하기" } },
                { menuLevel: 3, menuId: "mL3L2L3-2", parentId: "mL3L2-3", labelJson: { en_US: "신청현황조회", ko_KR: "신청현황조회" } },

                //about
                { menuLevel: 1, menuId: "mL4",     depth1:'ABOUT',  labelJson: { en_US: "ABOUT", ko_KR: "ABOUT" }, isNavOpen:false, },
                { menuLevel: 2, menuId: "mL4L2-1", parentId: "mL4", labelJson: { en_US: "GCRM소개", ko_KR: "GCRM소개" }, },
                { menuLevel: 2, menuId: "mL4L2-2", parentId: "mL4", labelJson: { en_US: "SYSTEM 매뉴얼", ko_KR: "SYSTEM 매뉴얼" }, },
                { menuLevel: 2, menuId: "mL4L2-3", parentId: "mL4", labelJson: { en_US: "담당자 정보", ko_KR: "담당자 정보" }, },
                { menuLevel: 2, menuId: "mL4L2-4", parentId: "mL4", labelJson: { en_US: "공지사항", ko_KR: "공지사항" }, },

                //admin
                { menuLevel: 1, menuId: "mL5",       depth1:'ADMIN',      labelJson: { en_US: "ADMIN",        ko_KR: "ADMIN" }, isNavOpen:false, },
                { menuLevel: 2, menuId: "mL5L2-1",   parentId: "mL5",     labelJson: { en_US: "데이터현황",    ko_KR: "데이터현황" }, },
                { menuLevel: 2, menuId: "mL5L2-2",   parentId: "mL5",     labelJson: { en_US: "I/F현황",       ko_KR: "I/F현황" }, },
                { menuLevel: 3, menuId: "mL5L2L3-1", parentId: "mL5L2-2", labelJson: { en_US: "시스템현황",     ko_KR: "시스템현황" } },
                { menuLevel: 3, menuId: "mL5L2L3-2", parentId: "mL5L2-2", labelJson: { en_US: "시스템상세현황", ko_KR: "시스템상세현황" } },
                { menuLevel: 2, menuId: "mL5L2-3",   parentId: "mL5",     labelJson: { en_US: "기준정보관리",   ko_KR: "기준정보관리" }, },
                { menuLevel: 2, menuId: "mL5L2-4",   parentId: "mL5",     labelJson: { en_US: "사용자권한권리", ko_KR: "사용자권한관리" },}, //220907 : 기획 메뉴명수정 (VOC -> Support)
            ],
            menuSelectedIndex:null,
            isMyInfoActive:false,
            myinfos :[
                {menu:"Campaign", submenus : {sub1:'China', sub2:'SEAO'}},
                {menu:"Loyalty", submenus : {sub1:'Korea', sub2 :'EU'}},
            ],
            
        }
    },
    computed: {
        rootMenus() {
        return _.sortBy(this.pubMenus.filter(menu => menu.menuLevel === 1 && menu.menuId !== 'COMM_URL'), ['menuSequence']);
        },
    },
    methods: {
        getSubmenu(parentId) {
            return _.sortBy(this.pubMenus.filter(menu => menu.parentId === parentId), ['menuSequence']);
        },
        navClick(menu, index, rootMenus) {
            rootMenus = rootMenus.map((item, i)=> {
                if(index === i) {
                    menu.isNavOpen = !menu.isNavOpen
                    this.menuSelectedIndex = index;
                } else {
                    item.isNavOpen = false
                }
            })
            document.addEventListener("click", function(e){
                if(!e.target.closest(".nav-item")) {
                    menu.isNavOpen = false
                }
            })
        },
        onInfoClick () {
            this.isMyInfoActive = !this.isMyInfoActive
            document.addEventListener("click", (e) => {
                if(!e.target.closest(".myinfo")) {
                    this.isMyInfoActive = false
                }
            })
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/markup/layout/PubHeader.vue